// https://api.hsforms.com/submissions/v3/integration/submit/7126023/d9367cac-a6c6-453c-a195-f620e32ca1a4

export function postToHubSpot(fields, pageUri, pageName, formType = 'SUPPORT'){
    const portlID = '7126023';
    let formGuid = 'd9367cac-a6c6-453c-a195-f620e32ca1a4'; // form de soporte. este guid va a cambiar dependiendo de cada tipo de form.
    // Rodrigo: probablemente no deberian estar definidas aquí?
    if (formType == 'CONTACT') {
        formGuid = 'cf7ee523-1afd-4434-a46a-6fc3b17ef067'; // form de ContactUS
    }

    let hubspotFormAPIURL = `https://api.hsforms.com/submissions/v3/integration/submit/${portlID}/${formGuid}`;

    let body = {
        "fields": fields,
        "context": {
            "pageUri": pageUri,
            "pageName": pageName
        }
    }

    return new Promise(async (resolve, reject) => {
        try {
            let serverResponse = await fetch(hubspotFormAPIURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body) 
            });
        
            if (serverResponse.status == 200) {
                
                let postResults = await serverResponse.json();
                resolve(postResults);
            }
            else {
                let postResults = await serverResponse.json();
                reject(postResults);
            }
        }
        catch (error) {
            reject(error);
        }
    });

}





